import { render, staticRenderFns } from "./accountSetPhoneLogin.vue?vue&type=template&id=736f64ff&"
import script from "./accountSetPhoneLogin.vue?vue&type=script&lang=js&"
export * from "./accountSetPhoneLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports